// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"rq-z","slideIn":"sq-z"};